import { Option } from '@anytag/shared-types';
import { Table, VisibilityState } from '@tanstack/react-table';

// TODO: can we custom a new column customizer component with this hook?
export const useToggleTableColumns = <TData, T extends string>() => {
  // Return the selectable columns, ignore the hidden and default visible columns
  const getSelectableColumns = (table: Table<TData>) => {
    const { selectableOptions, defaultOptions } = table.getAllColumns().reduce(
      (acc, curr) => {
        if ('accessorKey' in curr.columnDef && !curr.columnDef.meta?.hidden) {
          if (curr.getCanHide()) {
            acc.selectableOptions.push({
              label: curr.columnDef.header as string,
              value: curr.columnDef.accessorKey as T
            });
          } else {
            acc.defaultOptions.push(curr.columnDef.accessorKey as T);
          }
        }

        return acc;
      },
      { selectableOptions: [] as Option<T>[], defaultOptions: [] as T[] }
    );

    return { selectableOptions, defaultOptions };
  };

  const handleToggleColumns = (table: Table<TData>) => (columns: T[]) => {
    table.setColumnVisibility(columns.reduce<VisibilityState>((acc, curr) => ({ ...acc, [curr]: true }), {}));
  };

  return { getSelectableColumns, handleToggleColumns };
};
